import { takeLatest, put } from 'redux-saga/effects'
import moment from 'moment'

import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'
import { notificationCall } from 'syft-acp-core/sagas/calls'
import { editListingShiftStopOffers } from 'syft-acp-core/store/listing-shifts/actions'
import { store } from 'syft-acp-core/store'
import { showModal } from 'syft-acp-core/store/modals/actions'
import { fetchAdminShiftListing } from 'syft-acp-core/store/listing-shifts/actions'
import { fetchAdminBookings } from 'syft-acp-core/store/listings/actions'
import { fetchAgencyBookings } from 'syft-acp-core/actions/agency-bookings'
import { fetchAdminJob } from './actions'

import * as types from '../action-types'
import * as api from './api'

function* onSuccessCallback(action: any) {
  if (action?.payload?.warnings.length > 0) {
    store.dispatch(
      showModal('listingWarningModal', {
        warningData: action.payload.warnings,
      }),
    )
  }
  if (action?.request?.onSuccessCallback) {
    yield action?.request?.onSuccessCallback({})
  }
  const pastShift = moment(action.request?.shift?.start_time).isBefore(moment())
  // We are able to edit stop offers only in the future
  if (action.request.listingId && action.request?.shift?.id && !pastShift) {
    yield put(
      editListingShiftStopOffers(
        action.request.listingId,
        action.request.shift.id,
        action.request.data.stop_offers_for_worker_type,
      ),
    )
  }
  // This is a hack, because of roles are not returned after saving a job.
  // Remove this after new endpoint for job will be avaliable. https://syftapp.atlassian.net/browse/PTE-20205
  // and uncomment line in jobs/reducer.ts for job update.
  yield put(fetchAdminJob(action.request.id))
}

function* onExtendLTASuccess(action: any) {
  // Refresh the job data to get updated shifts after extending LTA
  yield put(fetchAdminJob(action.request.jobID))
}

function* onCancelLTAExtensionSuccess(action: any) {
  // Refresh the job data after canceling LTA extension
  yield put(fetchAdminJob(action.request.jobID))
}

function* onExtendBookingSuccess(action: any): Generator<any, void, any> {
  // Refresh the job data after extending booking
  yield put(fetchAdminJob(action.request.jobID))
  // Get current route info to refresh the active shift tab data
  const state = yield store.getState()
  const pathname = state?.router?.location?.pathname || state?.routing?.location?.pathname

  // Parse listing ID and shift ID from pathname like /listings/view/48/job/48/shift/87
  const pathMatch = pathname?.match(/\/listings\/view\/(\d+)\/job\/\d+\/shift\/(\d+)/)
  const currentListingID = pathMatch ? parseInt(pathMatch[1]) : null
  const currentShiftID = pathMatch ? parseInt(pathMatch[2]) : null
  if (currentListingID && currentShiftID) {
    yield put(fetchAdminShiftListing(currentListingID, currentShiftID))
    yield put(fetchAdminBookings(currentShiftID, action.request.jobID))
  }
}

function* onExtendAgencyBookingSuccess(action: any): Generator<any, void, any> {
  // Refresh the job data after extending agency booking
  yield put(fetchAdminJob(action.request.jobID))
  // Get current route info to refresh the active shift tab data
  const state = yield store.getState()
  const pathname = state?.router?.location?.pathname || state?.routing?.location?.pathname

  // Parse listing ID and shift ID from pathname like /listings/view/48/job/48/shift/87
  const pathMatch = pathname?.match(/\/listings\/view\/(\d+)\/job\/\d+\/shift\/(\d+)/)
  const currentListingID = pathMatch ? parseInt(pathMatch[1]) : null
  const currentShiftID = pathMatch ? parseInt(pathMatch[2]) : null
  if (currentListingID && currentShiftID) {
    yield put(fetchAdminShiftListing(currentListingID, currentShiftID))
    yield put(fetchAdminBookings(currentShiftID, action.request.jobID))
    yield put(fetchAgencyBookings(currentListingID, currentShiftID))
  }
}

export default function* root() {
  yield takeLatestApiCall(types.FETCH_ADMIN_JOB_BEGIN, api.fetchAdminJob)
  yield takeLatestApiCall('JOB_UPDATE', api.updateJob)
  yield takeLatestApiCall('JOB_RATE_WORKER', api.rateWorker)
  yield takeLatest([types.JOB_UPDATE_SUCCEEDED, types.JOB_UPDATE_FAILED], notificationCall)
  yield takeLatest([types.JOB_UPDATE_SUCCEEDED], onSuccessCallback)
  yield takeLatestApiCall('RATING_DELETE', api.ratingDelete)
  yield takeLatest([types.RATING_DELETE_FAILED, types.RATING_DELETE_SUCCEEDED], notificationCall)
  yield takeLatestApiCall('JOB_EXTEND_LTA', api.extendLTA)
  yield takeLatest([types.JOB_EXTEND_LTA_FAILED, types.JOB_EXTEND_LTA_SUCCEEDED], notificationCall)
  yield takeLatest([types.JOB_EXTEND_LTA_SUCCEEDED], onExtendLTASuccess)
  yield takeLatestApiCall('JOB_FETCH_LTA_EXTENSIONS', api.fetchLTAExtensions)
  yield takeLatestApiCall('JOB_CANCEL_LTA_EXTENSION', api.cancelLTAExtension)
  yield takeLatest(
    [types.JOB_CANCEL_LTA_EXTENSION_FAILED, types.JOB_CANCEL_LTA_EXTENSION_SUCCEEDED],
    notificationCall,
  )
  yield takeLatest([types.JOB_CANCEL_LTA_EXTENSION_SUCCEEDED], onCancelLTAExtensionSuccess)
  yield takeLatestApiCall('JOB_EXTEND_BOOKING', api.extendBooking)
  yield takeLatest([types.JOB_EXTEND_BOOKING_FAILED, types.JOB_EXTEND_BOOKING_SUCCEEDED], notificationCall)
  yield takeLatest([types.JOB_EXTEND_BOOKING_SUCCEEDED], onExtendBookingSuccess)
  yield takeLatestApiCall('JOB_EXTEND_AGENCY_BOOKING', api.extendAgencyBooking)
  yield takeLatest(
    [types.JOB_EXTEND_AGENCY_BOOKING_FAILED, types.JOB_EXTEND_AGENCY_BOOKING_SUCCEEDED],
    notificationCall,
  )
  yield takeLatest([types.JOB_EXTEND_AGENCY_BOOKING_SUCCEEDED], onExtendAgencyBookingSuccess)
}
